export default __webpack_public_path__ + "static/media/element_40.a1588e3e.jpg";